import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=25575d9c&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&id=25575d9c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25575d9c",
  null
  
)

export default component.exports